import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { StyledMultiColumnGroup } from './MultiColumnGroup';
import { ItemContainer } from './MultiColumnItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledMultiColumnSection = styled.div.withConfig({
  displayName: "MultiColumnSection__StyledMultiColumnSection",
  componentId: "var7cp-0"
})(["@media only screen and (min-width:576px){display:table-row-group;}> ", ":not(:first-child){border-color:transparent;> ", "{border-color:transparent;}}", ";"], StyledMultiColumnGroup, ItemContainer, ({
  $cssStyles
}) => $cssStyles);
export const MultiColumnSection = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledMultiColumnSection, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};